/**
 * @generated SignedSource<<b4ee8842a453b0f8dbb33e6135eb09fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgStoreWorkspaceBreadcrumbs_store$data = {
  readonly workspaceBreadcrumbs: ReadonlyArray<string>;
  readonly " $fragmentType": "OrgStoreWorkspaceBreadcrumbs_store";
};
export type OrgStoreWorkspaceBreadcrumbs_store$key = {
  readonly " $data"?: OrgStoreWorkspaceBreadcrumbs_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgStoreWorkspaceBreadcrumbs_store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentWorkspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgStoreWorkspaceBreadcrumbs_store",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "belowWorkspaceId",
          "variableName": "currentWorkspaceId"
        },
        {
          "kind": "Literal",
          "name": "includeExternalId",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "workspaceBreadcrumbs",
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "839afb9b7ae12043bb67226da520698b";

export default node;
